import type { Aggregate } from '../types/QueryTypes';
function computeAggregation(rows: Record<string, unknown>[], agg: Aggregate): unknown {
  const values = rows.map(r => r[agg.field]).filter(v => v !== null && v !== undefined && v !== '');
  switch (agg.op) {
    case 'count':
      return rows.length;
    case 'sum':
      {
        let total = 0;
        for (const v of values) total += Number(v);
        return total;
      }
    case 'avg':
      {
        if (values.length === 0) return 0;
        let total = 0;
        for (const v of values) total += Number(v);
        return total / values.length;
      }
    case 'min':
      {
        if (values.length === 0) return null;
        return Math.min(...values.map(Number));
      }
    case 'max':
      {
        if (values.length === 0) return null;
        return Math.max(...values.map(Number));
      }
    default:
      return null;
  }
}
export function applyGroupBy(rows: Record<string, unknown>[], groupBy: string, aggregates?: Aggregate[]): Record<string, unknown>[] {
  const groups = new Map<string, Record<string, unknown>[]>();
  for (const row of rows) {
    const raw = String(row[groupBy] ?? 'null');
    const keys = raw.includes(',') ? raw.split(',').map(k => k.trim()).filter(k => k.length > 0) : [raw];
    for (const key of keys) {
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key)!.push(row);
    }
  }
  const defaultAgg: Aggregate = {
    field: groupBy,
    op: 'count'
  };
  const aggs = aggregates && aggregates.length > 0 ? aggregates : [defaultAgg];
  const result: Record<string, unknown>[] = [];
  for (const [key, groupRows] of groups) {
    const record: Record<string, unknown> = {
      [groupBy]: key
    };
    for (const agg of aggs) {
      const colName = agg.op === 'count' && agg.field === groupBy ? 'count' : `${agg.field}_${agg.op}`;
      record[colName] = computeAggregation(groupRows, agg);
    }
    result.push(record);
  }
  return result;
}